import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { translationConstants, viewPathConstants } from "../../../constants";

const RegistrationSuccessModal = (props) => {
  const { handleRegSuccessContinueModal } = props
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleContinue = () => {
    if (handleRegSuccessContinueModal) {
      handleRegSuccessContinueModal()
    }
    else {
      navigate(viewPathConstants.DEFAULT_PATH);
    }
  };

  return (
    <>
      <p className="UnderView">
        {t(translationConstants.thankYouForRegistering)}
      </p>
      <span className="receivespan">
        {t(translationConstants.confirmationEmail)}
      </span>

      <span onClick={() => handleContinue()} className="GoBackPara text-decoration-underline">
        {t(translationConstants.continue)}
      </span>
    </>
  );
};

export default RegistrationSuccessModal;
